import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_UNIQUE_SLOTS_GET',
  GET_SUCCESS: 'STUDENT_UNIQUE_SLOTS_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_UNIQUE_SLOTS_GET_FAILURE',

  GET_ALL: 'STUDENT_UNIQUE_SLOTS_GET_ALL',
  GET_ALL_SUCCESS: 'STUDENT_UNIQUE_SLOTS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'STUDENT_UNIQUE_SLOTS_GET_ALL_FAILURE',

  PATCH: 'STUDENT_UNIQUE_SLOTS_PATCH',
  PATCH_SUCCESS: 'STUDENT_UNIQUE_SLOTS_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENT_UNIQUE_SLOTS_PATCH_FAILURE',
};

export const get = actions.get(
  (studentId, query, meta) => `${BASE_URL}/classroom/teacher-slots/?${stringify(meta)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const getAll = actions.getAll(
  (studentId, query) => `${BASE_URL}/classroom/teacher-slots/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const patch = actions.patch(
  studentSlotId => `${BASE_URL}/classroom/student-slots/${studentSlotId}`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
